/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * VT Platform — Identity API
 * Authentication subset of the Identity bounded context (API-001), governed by API-000. This contract is the source of truth for the generated frontend SDK (Orval → TanStack Query). It intentionally covers only the endpoints the Authentication UI consumes; the full Identity contract lives server-side.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CurrentUserResponse,
  EmailVerificationRequest,
  LoginRequest,
  PasswordResetConfirmation,
  PasswordResetRequest,
  ProblemResponse,
  RegistrationRequest,
  ResendVerificationRequest,
  SessionResponse,
  TokenResponse,
  UserResponse
} from '../model';

import { customInstance } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type registerAccountResponse201 = {
  data: UserResponse
  status: 201
}

export type registerAccountResponse400 = {
  data: ProblemResponse
  status: 400
}

export type registerAccountResponse409 = {
  data: ProblemResponse
  status: 409
}

export type registerAccountResponse422 = {
  data: ProblemResponse
  status: 422
}

export type registerAccountResponse429 = {
  data: ProblemResponse
  status: 429
}

export type registerAccountResponseSuccess = (registerAccountResponse201) & {
  headers: Headers;
};
export type registerAccountResponseError = (registerAccountResponse400 | registerAccountResponse409 | registerAccountResponse422 | registerAccountResponse429) & {
  headers: Headers;
};

export type registerAccountResponse = (registerAccountResponseSuccess | registerAccountResponseError)

export const getRegisterAccountUrl = () => {




  return `/auth/registration`
}

/**
 * @summary Register a new adult account and trigger email verification.
 */
export const registerAccount = async (registrationRequest: RegistrationRequest, options?: RequestInit): Promise<registerAccountResponse> => {

  return customInstance<registerAccountResponse>(getRegisterAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registrationRequest)
  }
);}





export const getRegisterAccountQueryKey = (registrationRequest?: RegistrationRequest,) => {
    return [
    'POST', `/auth/registration`, registrationRequest
    ] as const;
    }


export const getRegisterAccountQueryOptions = <TData = Awaited<ReturnType<typeof registerAccount>>, TError = ProblemResponse>(registrationRequest: RegistrationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRegisterAccountQueryKey(registrationRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof registerAccount>>> = ({ signal }) => registerAccount(registrationRequest, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof registerAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RegisterAccountQueryResult = NonNullable<Awaited<ReturnType<typeof registerAccount>>>
export type RegisterAccountQueryError = ProblemResponse


export function useRegisterAccount<TData = Awaited<ReturnType<typeof registerAccount>>, TError = ProblemResponse>(
 registrationRequest: RegistrationRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof registerAccount>>,
          TError,
          Awaited<ReturnType<typeof registerAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRegisterAccount<TData = Awaited<ReturnType<typeof registerAccount>>, TError = ProblemResponse>(
 registrationRequest: RegistrationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof registerAccount>>,
          TError,
          Awaited<ReturnType<typeof registerAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRegisterAccount<TData = Awaited<ReturnType<typeof registerAccount>>, TError = ProblemResponse>(
 registrationRequest: RegistrationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Register a new adult account and trigger email verification.
 */

export function useRegisterAccount<TData = Awaited<ReturnType<typeof registerAccount>>, TError = ProblemResponse>(
 registrationRequest: RegistrationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof registerAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRegisterAccountQueryOptions(registrationRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type requestEmailVerificationResponse202 = {
  data: void
  status: 202
}

export type requestEmailVerificationResponse400 = {
  data: ProblemResponse
  status: 400
}

export type requestEmailVerificationResponse429 = {
  data: ProblemResponse
  status: 429
}

export type requestEmailVerificationResponseSuccess = (requestEmailVerificationResponse202) & {
  headers: Headers;
};
export type requestEmailVerificationResponseError = (requestEmailVerificationResponse400 | requestEmailVerificationResponse429) & {
  headers: Headers;
};

export type requestEmailVerificationResponse = (requestEmailVerificationResponseSuccess | requestEmailVerificationResponseError)

export const getRequestEmailVerificationUrl = () => {




  return `/auth/email-verification/requests`
}

/**
 * Public and anti-enumeration: names the address to send a fresh link to. An unknown, deleted, or already-verified address is a silent no-op, so the response is a uniform 202 that never reveals whether the address exists.
 * @summary (Re)send an email-verification challenge to the given address.
 */
export const requestEmailVerification = async (resendVerificationRequest: ResendVerificationRequest, options?: RequestInit): Promise<requestEmailVerificationResponse> => {

  return customInstance<requestEmailVerificationResponse>(getRequestEmailVerificationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resendVerificationRequest)
  }
);}





export const getRequestEmailVerificationQueryKey = (resendVerificationRequest?: ResendVerificationRequest,) => {
    return [
    'POST', `/auth/email-verification/requests`, resendVerificationRequest
    ] as const;
    }


export const getRequestEmailVerificationQueryOptions = <TData = Awaited<ReturnType<typeof requestEmailVerification>>, TError = ProblemResponse>(resendVerificationRequest: ResendVerificationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestEmailVerification>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRequestEmailVerificationQueryKey(resendVerificationRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof requestEmailVerification>>> = ({ signal }) => requestEmailVerification(resendVerificationRequest, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof requestEmailVerification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RequestEmailVerificationQueryResult = NonNullable<Awaited<ReturnType<typeof requestEmailVerification>>>
export type RequestEmailVerificationQueryError = ProblemResponse


export function useRequestEmailVerification<TData = Awaited<ReturnType<typeof requestEmailVerification>>, TError = ProblemResponse>(
 resendVerificationRequest: ResendVerificationRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestEmailVerification>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof requestEmailVerification>>,
          TError,
          Awaited<ReturnType<typeof requestEmailVerification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequestEmailVerification<TData = Awaited<ReturnType<typeof requestEmailVerification>>, TError = ProblemResponse>(
 resendVerificationRequest: ResendVerificationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestEmailVerification>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof requestEmailVerification>>,
          TError,
          Awaited<ReturnType<typeof requestEmailVerification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequestEmailVerification<TData = Awaited<ReturnType<typeof requestEmailVerification>>, TError = ProblemResponse>(
 resendVerificationRequest: ResendVerificationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestEmailVerification>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary (Re)send an email-verification challenge to the given address.
 */

export function useRequestEmailVerification<TData = Awaited<ReturnType<typeof requestEmailVerification>>, TError = ProblemResponse>(
 resendVerificationRequest: ResendVerificationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestEmailVerification>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRequestEmailVerificationQueryOptions(resendVerificationRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type confirmEmailVerificationResponse200 = {
  data: UserResponse
  status: 200
}

export type confirmEmailVerificationResponse400 = {
  data: ProblemResponse
  status: 400
}

export type confirmEmailVerificationResponse409 = {
  data: ProblemResponse
  status: 409
}

export type confirmEmailVerificationResponse410 = {
  data: ProblemResponse
  status: 410
}

export type confirmEmailVerificationResponse422 = {
  data: ProblemResponse
  status: 422
}

export type confirmEmailVerificationResponseSuccess = (confirmEmailVerificationResponse200) & {
  headers: Headers;
};
export type confirmEmailVerificationResponseError = (confirmEmailVerificationResponse400 | confirmEmailVerificationResponse409 | confirmEmailVerificationResponse410 | confirmEmailVerificationResponse422) & {
  headers: Headers;
};

export type confirmEmailVerificationResponse = (confirmEmailVerificationResponseSuccess | confirmEmailVerificationResponseError)

export const getConfirmEmailVerificationUrl = () => {




  return `/auth/email-verification/confirmations`
}

/**
 * @summary Confirm email ownership using the emailed token.
 */
export const confirmEmailVerification = async (emailVerificationRequest: EmailVerificationRequest, options?: RequestInit): Promise<confirmEmailVerificationResponse> => {

  return customInstance<confirmEmailVerificationResponse>(getConfirmEmailVerificationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(emailVerificationRequest)
  }
);}





export const getConfirmEmailVerificationQueryKey = (emailVerificationRequest?: EmailVerificationRequest,) => {
    return [
    'POST', `/auth/email-verification/confirmations`, emailVerificationRequest
    ] as const;
    }


export const getConfirmEmailVerificationQueryOptions = <TData = Awaited<ReturnType<typeof confirmEmailVerification>>, TError = ProblemResponse>(emailVerificationRequest: EmailVerificationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof confirmEmailVerification>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConfirmEmailVerificationQueryKey(emailVerificationRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof confirmEmailVerification>>> = ({ signal }) => confirmEmailVerification(emailVerificationRequest, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof confirmEmailVerification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConfirmEmailVerificationQueryResult = NonNullable<Awaited<ReturnType<typeof confirmEmailVerification>>>
export type ConfirmEmailVerificationQueryError = ProblemResponse


export function useConfirmEmailVerification<TData = Awaited<ReturnType<typeof confirmEmailVerification>>, TError = ProblemResponse>(
 emailVerificationRequest: EmailVerificationRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof confirmEmailVerification>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof confirmEmailVerification>>,
          TError,
          Awaited<ReturnType<typeof confirmEmailVerification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConfirmEmailVerification<TData = Awaited<ReturnType<typeof confirmEmailVerification>>, TError = ProblemResponse>(
 emailVerificationRequest: EmailVerificationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof confirmEmailVerification>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof confirmEmailVerification>>,
          TError,
          Awaited<ReturnType<typeof confirmEmailVerification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConfirmEmailVerification<TData = Awaited<ReturnType<typeof confirmEmailVerification>>, TError = ProblemResponse>(
 emailVerificationRequest: EmailVerificationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof confirmEmailVerification>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Confirm email ownership using the emailed token.
 */

export function useConfirmEmailVerification<TData = Awaited<ReturnType<typeof confirmEmailVerification>>, TError = ProblemResponse>(
 emailVerificationRequest: EmailVerificationRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof confirmEmailVerification>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConfirmEmailVerificationQueryOptions(emailVerificationRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createSessionResponse201 = {
  data: SessionResponse
  status: 201
}

export type createSessionResponse400 = {
  data: ProblemResponse
  status: 400
}

export type createSessionResponse401 = {
  data: ProblemResponse
  status: 401
}

export type createSessionResponse403 = {
  data: ProblemResponse
  status: 403
}

export type createSessionResponse429 = {
  data: ProblemResponse
  status: 429
}

export type createSessionResponseSuccess = (createSessionResponse201) & {
  headers: Headers;
};
export type createSessionResponseError = (createSessionResponse400 | createSessionResponse401 | createSessionResponse403 | createSessionResponse429) & {
  headers: Headers;
};

export type createSessionResponse = (createSessionResponseSuccess | createSessionResponseError)

export const getCreateSessionUrl = () => {




  return `/auth/sessions`
}

/**
 * @summary Authenticate credentials and establish a session (login).
 */
export const createSession = async (loginRequest: LoginRequest, options?: RequestInit): Promise<createSessionResponse> => {

  return customInstance<createSessionResponse>(getCreateSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loginRequest)
  }
);}





export const getCreateSessionQueryKey = (loginRequest?: LoginRequest,) => {
    return [
    'POST', `/auth/sessions`, loginRequest
    ] as const;
    }


export const getCreateSessionQueryOptions = <TData = Awaited<ReturnType<typeof createSession>>, TError = ProblemResponse>(loginRequest: LoginRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreateSessionQueryKey(loginRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof createSession>>> = ({ signal }) => createSession(loginRequest, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof createSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CreateSessionQueryResult = NonNullable<Awaited<ReturnType<typeof createSession>>>
export type CreateSessionQueryError = ProblemResponse


export function useCreateSession<TData = Awaited<ReturnType<typeof createSession>>, TError = ProblemResponse>(
 loginRequest: LoginRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof createSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createSession>>,
          TError,
          Awaited<ReturnType<typeof createSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateSession<TData = Awaited<ReturnType<typeof createSession>>, TError = ProblemResponse>(
 loginRequest: LoginRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createSession>>,
          TError,
          Awaited<ReturnType<typeof createSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCreateSession<TData = Awaited<ReturnType<typeof createSession>>, TError = ProblemResponse>(
 loginRequest: LoginRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Authenticate credentials and establish a session (login).
 */

export function useCreateSession<TData = Awaited<ReturnType<typeof createSession>>, TError = ProblemResponse>(
 loginRequest: LoginRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCreateSessionQueryOptions(loginRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type deleteCurrentSessionResponse204 = {
  data: void
  status: 204
}

export type deleteCurrentSessionResponse401 = {
  data: ProblemResponse
  status: 401
}

export type deleteCurrentSessionResponseSuccess = (deleteCurrentSessionResponse204) & {
  headers: Headers;
};
export type deleteCurrentSessionResponseError = (deleteCurrentSessionResponse401) & {
  headers: Headers;
};

export type deleteCurrentSessionResponse = (deleteCurrentSessionResponseSuccess | deleteCurrentSessionResponseError)

export const getDeleteCurrentSessionUrl = () => {




  return `/auth/sessions/current`
}

/**
 * @summary Revoke the current session and its refresh-token family (logout).
 */
export const deleteCurrentSession = async ( options?: RequestInit): Promise<deleteCurrentSessionResponse> => {

  return customInstance<deleteCurrentSessionResponse>(getDeleteCurrentSessionUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCurrentSessionQueryKey = () => {
    return [
    'DELETE', `/auth/sessions/current`
    ] as const;
    }


export const getDeleteCurrentSessionQueryOptions = <TData = Awaited<ReturnType<typeof deleteCurrentSession>>, TError = ProblemResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteCurrentSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeleteCurrentSessionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteCurrentSession>>> = ({ signal }) => deleteCurrentSession({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof deleteCurrentSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DeleteCurrentSessionQueryResult = NonNullable<Awaited<ReturnType<typeof deleteCurrentSession>>>
export type DeleteCurrentSessionQueryError = ProblemResponse


export function useDeleteCurrentSession<TData = Awaited<ReturnType<typeof deleteCurrentSession>>, TError = ProblemResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteCurrentSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteCurrentSession>>,
          TError,
          Awaited<ReturnType<typeof deleteCurrentSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteCurrentSession<TData = Awaited<ReturnType<typeof deleteCurrentSession>>, TError = ProblemResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteCurrentSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteCurrentSession>>,
          TError,
          Awaited<ReturnType<typeof deleteCurrentSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDeleteCurrentSession<TData = Awaited<ReturnType<typeof deleteCurrentSession>>, TError = ProblemResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteCurrentSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Revoke the current session and its refresh-token family (logout).
 */

export function useDeleteCurrentSession<TData = Awaited<ReturnType<typeof deleteCurrentSession>>, TError = ProblemResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteCurrentSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDeleteCurrentSessionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type refreshAccessTokenResponse200 = {
  data: TokenResponse
  status: 200
}

export type refreshAccessTokenResponse401 = {
  data: ProblemResponse
  status: 401
}

export type refreshAccessTokenResponse403 = {
  data: ProblemResponse
  status: 403
}

export type refreshAccessTokenResponse429 = {
  data: ProblemResponse
  status: 429
}

export type refreshAccessTokenResponseSuccess = (refreshAccessTokenResponse200) & {
  headers: Headers;
};
export type refreshAccessTokenResponseError = (refreshAccessTokenResponse401 | refreshAccessTokenResponse403 | refreshAccessTokenResponse429) & {
  headers: Headers;
};

export type refreshAccessTokenResponse = (refreshAccessTokenResponseSuccess | refreshAccessTokenResponseError)

export const getRefreshAccessTokenUrl = () => {




  return `/auth/token/refresh`
}

/**
 * @summary Exchange a rotating refresh token for a new access token.
 */
export const refreshAccessToken = async ( options?: RequestInit): Promise<refreshAccessTokenResponse> => {

  return customInstance<refreshAccessTokenResponse>(getRefreshAccessTokenUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRefreshAccessTokenQueryKey = () => {
    return [
    'POST', `/auth/token/refresh`
    ] as const;
    }


export const getRefreshAccessTokenQueryOptions = <TData = Awaited<ReturnType<typeof refreshAccessToken>>, TError = ProblemResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshAccessToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRefreshAccessTokenQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof refreshAccessToken>>> = ({ signal }) => refreshAccessToken({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof refreshAccessToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RefreshAccessTokenQueryResult = NonNullable<Awaited<ReturnType<typeof refreshAccessToken>>>
export type RefreshAccessTokenQueryError = ProblemResponse


export function useRefreshAccessToken<TData = Awaited<ReturnType<typeof refreshAccessToken>>, TError = ProblemResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshAccessToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof refreshAccessToken>>,
          TError,
          Awaited<ReturnType<typeof refreshAccessToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRefreshAccessToken<TData = Awaited<ReturnType<typeof refreshAccessToken>>, TError = ProblemResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshAccessToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof refreshAccessToken>>,
          TError,
          Awaited<ReturnType<typeof refreshAccessToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRefreshAccessToken<TData = Awaited<ReturnType<typeof refreshAccessToken>>, TError = ProblemResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshAccessToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Exchange a rotating refresh token for a new access token.
 */

export function useRefreshAccessToken<TData = Awaited<ReturnType<typeof refreshAccessToken>>, TError = ProblemResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof refreshAccessToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRefreshAccessTokenQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type requestPasswordResetResponse202 = {
  data: void
  status: 202
}

export type requestPasswordResetResponse400 = {
  data: ProblemResponse
  status: 400
}

export type requestPasswordResetResponse429 = {
  data: ProblemResponse
  status: 429
}

export type requestPasswordResetResponseSuccess = (requestPasswordResetResponse202) & {
  headers: Headers;
};
export type requestPasswordResetResponseError = (requestPasswordResetResponse400 | requestPasswordResetResponse429) & {
  headers: Headers;
};

export type requestPasswordResetResponse = (requestPasswordResetResponseSuccess | requestPasswordResetResponseError)

export const getRequestPasswordResetUrl = () => {




  return `/auth/password-reset/requests`
}

/**
 * @summary Begin password recovery; emails a reset token.
 */
export const requestPasswordReset = async (passwordResetRequest: PasswordResetRequest, options?: RequestInit): Promise<requestPasswordResetResponse> => {

  return customInstance<requestPasswordResetResponse>(getRequestPasswordResetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(passwordResetRequest)
  }
);}





export const getRequestPasswordResetQueryKey = (passwordResetRequest?: PasswordResetRequest,) => {
    return [
    'POST', `/auth/password-reset/requests`, passwordResetRequest
    ] as const;
    }


export const getRequestPasswordResetQueryOptions = <TData = Awaited<ReturnType<typeof requestPasswordReset>>, TError = ProblemResponse>(passwordResetRequest: PasswordResetRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRequestPasswordResetQueryKey(passwordResetRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof requestPasswordReset>>> = ({ signal }) => requestPasswordReset(passwordResetRequest, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RequestPasswordResetQueryResult = NonNullable<Awaited<ReturnType<typeof requestPasswordReset>>>
export type RequestPasswordResetQueryError = ProblemResponse


export function useRequestPasswordReset<TData = Awaited<ReturnType<typeof requestPasswordReset>>, TError = ProblemResponse>(
 passwordResetRequest: PasswordResetRequest, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof requestPasswordReset>>,
          TError,
          Awaited<ReturnType<typeof requestPasswordReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequestPasswordReset<TData = Awaited<ReturnType<typeof requestPasswordReset>>, TError = ProblemResponse>(
 passwordResetRequest: PasswordResetRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof requestPasswordReset>>,
          TError,
          Awaited<ReturnType<typeof requestPasswordReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRequestPasswordReset<TData = Awaited<ReturnType<typeof requestPasswordReset>>, TError = ProblemResponse>(
 passwordResetRequest: PasswordResetRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Begin password recovery; emails a reset token.
 */

export function useRequestPasswordReset<TData = Awaited<ReturnType<typeof requestPasswordReset>>, TError = ProblemResponse>(
 passwordResetRequest: PasswordResetRequest, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRequestPasswordResetQueryOptions(passwordResetRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type confirmPasswordResetResponse204 = {
  data: void
  status: 204
}

export type confirmPasswordResetResponse400 = {
  data: ProblemResponse
  status: 400
}

export type confirmPasswordResetResponse410 = {
  data: ProblemResponse
  status: 410
}

export type confirmPasswordResetResponse422 = {
  data: ProblemResponse
  status: 422
}

export type confirmPasswordResetResponseSuccess = (confirmPasswordResetResponse204) & {
  headers: Headers;
};
export type confirmPasswordResetResponseError = (confirmPasswordResetResponse400 | confirmPasswordResetResponse410 | confirmPasswordResetResponse422) & {
  headers: Headers;
};

export type confirmPasswordResetResponse = (confirmPasswordResetResponseSuccess | confirmPasswordResetResponseError)

export const getConfirmPasswordResetUrl = () => {




  return `/auth/password-reset/confirmations`
}

/**
 * @summary Set a new password using the reset token.
 */
export const confirmPasswordReset = async (passwordResetConfirmation: PasswordResetConfirmation, options?: RequestInit): Promise<confirmPasswordResetResponse> => {

  return customInstance<confirmPasswordResetResponse>(getConfirmPasswordResetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(passwordResetConfirmation)
  }
);}





export const getConfirmPasswordResetQueryKey = (passwordResetConfirmation?: PasswordResetConfirmation,) => {
    return [
    'POST', `/auth/password-reset/confirmations`, passwordResetConfirmation
    ] as const;
    }


export const getConfirmPasswordResetQueryOptions = <TData = Awaited<ReturnType<typeof confirmPasswordReset>>, TError = ProblemResponse>(passwordResetConfirmation: PasswordResetConfirmation, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConfirmPasswordResetQueryKey(passwordResetConfirmation);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof confirmPasswordReset>>> = ({ signal }) => confirmPasswordReset(passwordResetConfirmation, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConfirmPasswordResetQueryResult = NonNullable<Awaited<ReturnType<typeof confirmPasswordReset>>>
export type ConfirmPasswordResetQueryError = ProblemResponse


export function useConfirmPasswordReset<TData = Awaited<ReturnType<typeof confirmPasswordReset>>, TError = ProblemResponse>(
 passwordResetConfirmation: PasswordResetConfirmation, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof confirmPasswordReset>>,
          TError,
          Awaited<ReturnType<typeof confirmPasswordReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConfirmPasswordReset<TData = Awaited<ReturnType<typeof confirmPasswordReset>>, TError = ProblemResponse>(
 passwordResetConfirmation: PasswordResetConfirmation, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof confirmPasswordReset>>,
          TError,
          Awaited<ReturnType<typeof confirmPasswordReset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConfirmPasswordReset<TData = Awaited<ReturnType<typeof confirmPasswordReset>>, TError = ProblemResponse>(
 passwordResetConfirmation: PasswordResetConfirmation, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Set a new password using the reset token.
 */

export function useConfirmPasswordReset<TData = Awaited<ReturnType<typeof confirmPasswordReset>>, TError = ProblemResponse>(
 passwordResetConfirmation: PasswordResetConfirmation, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConfirmPasswordResetQueryOptions(passwordResetConfirmation,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getCurrentUserResponse200 = {
  data: CurrentUserResponse
  status: 200
}

export type getCurrentUserResponse401 = {
  data: ProblemResponse
  status: 401
}

export type getCurrentUserResponseSuccess = (getCurrentUserResponse200) & {
  headers: Headers;
};
export type getCurrentUserResponseError = (getCurrentUserResponse401) & {
  headers: Headers;
};

export type getCurrentUserResponse = (getCurrentUserResponseSuccess | getCurrentUserResponseError)

export const getGetCurrentUserUrl = () => {




  return `/users/me`
}

/**
 * Composition endpoint (owned by no single bounded context): the Identity account plus the account's Organization staff membership. `staffMembership` is null for the vast majority of users, who are not staff.
 * @summary Return the authenticated account composed with its staff membership.
 */
export const getCurrentUser = async ( options?: RequestInit): Promise<getCurrentUserResponse> => {

  return customInstance<getCurrentUserResponse>(getGetCurrentUserUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentUserQueryKey = () => {
    return [
    `/users/me`
    ] as const;
    }


export const getGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ProblemResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({ signal }) => getCurrentUser({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>
export type GetCurrentUserQueryError = ProblemResponse


export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ProblemResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ProblemResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ProblemResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Return the authenticated account composed with its staff membership.
 */

export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ProblemResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






